import { clamp } from 'utils/math'

const DEFAULT_STEP_PX = 8

export function applyColumnResizeKey(
  event: { key: string; preventDefault: () => void },
  {
    currentWidth,
    minWidth,
    maxWidth,
    step = DEFAULT_STEP_PX,
  }: {
    currentWidth: number
    minWidth: number
    maxWidth: number
    step?: number
  },
) {
  if (event.key === 'ArrowLeft') {
    event.preventDefault()
    return clamp(currentWidth - step, minWidth, maxWidth)
  }
  if (event.key === 'ArrowRight') {
    event.preventDefault()
    return clamp(currentWidth + step, minWidth, maxWidth)
  }
  if (event.key === 'Home') {
    event.preventDefault()
    return minWidth
  }
  if (event.key === 'End') {
    event.preventDefault()
    return maxWidth
  }
}

export function handleColumnResizeKey(
  event: { key: string; preventDefault: () => void },
  options: {
    currentWidth: number
    minWidth: number
    maxWidth: number
    onChange: (width: number) => void
    step?: number
  },
) {
  const next = applyColumnResizeKey(event, options)
  if (next !== undefined) {
    options.onChange(next)
  }
}
